import { Link } from 'react-router-dom'
import styled from 'styled-components'
import getStudents, { Student } from '../libs/student-service'
import SkillLabel from './SkillLabel'
import { useEffect, useState } from 'react'
import { Class } from '../libs/login-service'
import { Batch } from '../libs/batch-service'
import { BsGenderFemale } from 'react-icons/bs'
import { BsGenderMale } from 'react-icons/bs'

const StudentTableWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
`

const Table = styled.table`
    width: 100%;
    padding: 20px;
    border-bottom: 1px solid #e5e6eb;
    border-collapse: collapse;
`
const TR = styled.tr`
    border-bottom: 1px solid #e5e6eb;
    border-collapse: collapse;
`

const TD = styled.td`
    padding: 10px;
    border-bottom: 1px solid #e5e6eb;
    border-collapse: collapse;
`

const NameColumn = styled.td`
    text-align: left;
    padding: 5px;
`

const FemaleIcon = styled(BsGenderFemale)`
    color: #ff69b4;
`

const MaleIcon = styled(BsGenderMale)`
    color: #1e90ff;
`

interface Props {
    setStudent: React.Dispatch<React.SetStateAction<Student | null>>
    badgeClick: (student: Student, skill: string) => void
    selectedClass: Class
    batch: Batch | undefined
}

export default function StudentTable({
    setStudent,
    badgeClick,
    selectedClass,
    batch,
}: Props) {
    const [students, setStudents] = useState<Student[]>([])

    useEffect(() => {
        const fetchStudents = async () => {
            if (!selectedClass || !batch) {
                return
            }

            const { students } = await getStudents(selectedClass.id, batch.id)
            setStudents(students)

            if (students.length === 0) {
                setStudent(null)
            }

            setStudent(students[0])
        }

        const updateStudents = async () => {
            if (!selectedClass || !batch) {
                return
            }

            const { students } = await getStudents(selectedClass.id, batch.id)
            setStudents(students)
        }

        const interval = setInterval(() => {
            try {
                updateStudents()
            } catch (e) {}
        }, 6000)

        fetchStudents()
        return () => clearInterval(interval)
    }, [selectedClass, batch])

    return (
        <StudentTableWrapper>
            <Table>
                <thead>
                    <TR>
                        <NameColumn>Name</NameColumn>
                        <TD>Gender</TD>
                        <NameColumn>Student ID</NameColumn>
                        <TD>Jump</TD>
                        <TD>Skip</TD>
                        <TD>Hop</TD>
                        <TD>Sidestep</TD>
                        <TD>Kick</TD>
                        <TD>Throw</TD>
                        <TD>Catch</TD>
                    </TR>
                </thead>
                <tbody>
                    {students.map((s, i) => {
                        return (
                            <TR key={i} onClick={() => setStudent(s)}>
                                <NameColumn>
                                    <Link to={`/student/${s.id}`}>
                                        {s.first_name} {s.last_name}
                                    </Link>
                                </NameColumn>
                                <TD>
                                    {s.gender === 'Male' ? (
                                        <MaleIcon />
                                    ) : (
                                        <FemaleIcon />
                                    )}
                                </TD>
                                <NameColumn>{s.student_id}</NameColumn>

                                <TD>
                                    <div onClick={() => badgeClick(s, 'Jump')}>
                                        <SkillLabel
                                            status={
                                                s.assessments.find((a) => {
                                                    return a.skill === 'Jump'
                                                })?.result
                                            }
                                        />
                                    </div>
                                </TD>
                                <TD>
                                    <div onClick={() => badgeClick(s, 'Skip')}>
                                        <SkillLabel
                                            status={
                                                s.assessments.find((a) => {
                                                    return a.skill === 'Skip'
                                                })?.result
                                            }
                                        />
                                    </div>
                                </TD>
                                <TD>
                                    <div onClick={() => badgeClick(s, 'Hop')}>
                                        <SkillLabel
                                            status={
                                                s.assessments.find((a) => {
                                                    return a.skill === 'Hop'
                                                })?.result
                                            }
                                        />
                                    </div>
                                </TD>
                                <TD>
                                    <div
                                        onClick={() =>
                                            badgeClick(s, 'Sidestep')
                                        }
                                    >
                                        <SkillLabel
                                            status={
                                                s.assessments.find((a) => {
                                                    return (
                                                        a.skill === 'Sidestep'
                                                    )
                                                })?.result
                                            }
                                        />
                                    </div>
                                </TD>
                                <TD>
                                    <div onClick={() => badgeClick(s, 'Kick')}>
                                        <SkillLabel
                                            status={
                                                s.assessments.find((a) => {
                                                    return a.skill === 'Kick'
                                                })?.result
                                            }
                                        />
                                    </div>
                                </TD>
                                <TD>
                                    <div onClick={() => badgeClick(s, 'Throw')}>
                                        <SkillLabel
                                            status={
                                                s.assessments.find((a) => {
                                                    return a.skill === 'Throw'
                                                })?.result
                                            }
                                        />
                                    </div>
                                </TD>
                                <TD>
                                    <div onClick={() => badgeClick(s, 'Catch')}>
                                        <SkillLabel
                                            status={
                                                s.assessments.find((a) => {
                                                    return a.skill === 'Catch'
                                                })?.result
                                            }
                                        />
                                    </div>
                                </TD>
                            </TR>
                        )
                    })}
                </tbody>
            </Table>
            {students.length === 0 && (
                <div> No students - Plesae import student info</div>
            )}
        </StudentTableWrapper>
    )
}
